export default __webpack_public_path__ + "images/onboarding/splashverse-onboarding-math-v2-de56bf27631357a96c2b4f7da1ea1e0e.png";